import { configureLocalization } from "@lit/localize";
import { sourceLocale, targetLocales } from "./generated/locale-codes.js";

export const localeNames = {
  de: "Deutsch",
};

// Nur de (Abschnitt 7 der Anforderungen) — Zielgruppe ist lokal. Weitere
// Locales: targetLocales in lit-localize.json ergänzen, xliff/<locale>.xlf
// anlegen, hier den Import-Switch erweitern.
export const { getLocale, setLocale } = configureLocalization({
  sourceLocale,
  targetLocales,
  loadLocale: () => import("./generated/locales/de.js"),
});

/** localStorage-Key für die Sprachwahl — geschrieben in `_setLocale()`. */
export const LANGUAGE_SELECTION_KEY = "app.language.selection";

export const DEFAULT_LOCALE = "de";

/**
 * Beim App-Start (statische Init, vor `startInit`) aufrufen: übernimmt die
 * gespeicherte Sprachwahl bzw. den Default. Ohne diesen Schritt bliebe die App
 * auf der Source-Locale "dev" und zeigt unübersetzte Strings.
 *
 * @returns die aktivierte Locale (für `_selectedLocale`)
 */
export function initLocale(): string {
  const stored = localStorage.getItem(LANGUAGE_SELECTION_KEY);
  const locale =
    stored && (targetLocales as readonly string[]).includes(stored) ? stored : DEFAULT_LOCALE;
  setLocale(locale);
  return locale;
}
